import { coappGetUserCoapplicants, coappGetGroup, coappRemove, coappAccept, coappDecline } from "./api_client/api_coapplicant";
import Modal from "./Modal";
import EventBus from "./Event";

class CoappsTable {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$body = this.$el.find('[data-coapps-table="body"]');
    this.$template = this.$el.find('[data-coapps-row-template]');
    this.$tplClone = this.$template.clone();

    this.$template.remove();
    this.coapplicants = [];

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.initTable.bind(this));

    this.$el.find('[data-coapps-table="body"]')
      .on('click', '[data-coapps-table="actions-trigger"]', this.onActionsTrigger.bind(this))
      .on('click', '[data-coapps-table="actions-remove"]', this.onRemoveCoapplicant.bind(this))
      .on('click', '[data-coapps-table="actions-accept"]', this.onAcceptCoapplicant.bind(this))
      .on('click', '[data-coapps-table="actions-decline"]', this.onDeclineCoapplicant.bind(this));

    $(document.body)
      .on('click', '[data-form-action="confirm-remove-coapplicant"]', this.onConfirmRemoveCoapplicant.bind(this));
  }

  async initTable() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    await this.getUserCoapplicants(user.auth.email);
    // await this.getCoapplicantsGroup(user.auth.email);
    this.render();
  }

  async getUserCoapplicants(email) {
    const user = window.grapp.user;

    const coapps = await coappGetUserCoapplicants(user.auth.email);
    if (coapps.success && coapps.fields) {
      this.coapplicants = coapps.fields.coapplicants || [];
      this.userIsInviter = coapps.fields.coapplicants_owner_info?.is_inviter;
    } else {
      console.log('No coapplicants found');
      // @todo: render 'no coapplicants' row
    }
  }

  // temporary (testing endpoint for coapplicants group)
  async getCoapplicantsGroup(email) {
    const user = window.grapp.user;

    const groups = await coappGetGroup(user.auth.email);
    console.log('groups: ', groups);
    if (groups.success && groups.fields) {
      // this.coapplicantsGroup = groups.fields.find(group => {
      //   return group.coapplicants && group.coapplicants.length && group.coapplicants[0].email;
      // });
      // console.log('this.coapplicantsGroup: ', this.coapplicantsGroup);
      this.coapplicantsGroups = groups.fields;
      console.log('this.coapplicantsGroups: ', this.coapplicantsGroups);
    } else {
      console.log('No coapplicants group found');
    }
  }

  render() {
    console.log('rendering table');
    if (!this.coapplicants || !this.coapplicants.length) {
      const $row = this.getRowTemplate({ email: '--', coapp_row_id: 0 });
      this.$body.append($row);
      return;
    } else {
      // remove 'no coapplicants' row
      this.$body.find('[data-coapps-table="row"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('coapp-row-id') == 0) {
          $el.remove();
        }
      })
    }

    this.coapplicants.forEach(coapplicant => {
      const $row = this.getRowTemplate(coapplicant);
      this.$body.append($row);
    });
  }

  renderRow(coapplicant) {
    const $row = this.getRowTemplate(coapplicant);
    this.$body.append($row);

    if (coapplicant.coapp_row_id === 0) {
      this.$body.find('[data-coapps-table="row"]').forEach((i, el) => {
        const $el = $(el);
        if ($el.data('coapp-row-id') == 0) {
          $el.remove();
        }
      });
    }
  }

  getRowTemplate(coapplicant) {
    console.log('coapplicant: ', coapplicant);
    const $row = this.$tplClone.clone();
    $row.find('[data-coapps-table="coapp-email"]').text(coapplicant.email || '--');
    $row.find('[data-coapps-table="coapp-name"]')
      .text(coapplicant.email === '--' ? 'No coapplicants' : `${coapplicant.first_name} ${coapplicant.last_name}`);
    $row.find('[data-coapps-table="coapp-phone"]').text(coapplicant.phone_number || '--');

    coapplicant.status = coapplicant.status || (this.userIsInviter ? 'Invited' : 'New Request');
    const statusClassMap = { 
      'New Request': 'bg_primary_light', 'Connected': 'bg_primary', 'App Declined': 'bg_text_light', 'App Approved': 'bg_secondary', 'Invited': 'bg_borders'
    };
    // const statusTextMap = { 'approved': 'Approved', 'pending': 'Pending', 'rejected': 'Rejected', 'draft': 'Draft' };
    const $rowStatusIcon = $row.find('[data-coapps-table="coapp-status"] div').first();
    const $rowStatusText = $row.find('[data-coapps-table="coapp-status"] div').last();
    if (coapplicant.email == '--') {
      $rowStatusText.text('--');
    } else {
      $rowStatusIcon.addClass(statusClassMap[coapplicant.status]);
      $rowStatusText.text(coapplicant.status);
    }

    const rowId = coapplicant.email == '--' ? "0" : coapplicant.email;
    console.log('rowId: ', rowId);
    $row.attr('data-coapp-row-id', coapplicant.email == '--' ? "0" : coapplicant.email);

    if (coapplicant.email === '--') {
      const $rowActionsTrigger = $row.find('[data-coapps-table="actions-trigger"]');
      $rowActionsTrigger.parent().html('--');
      $rowActionsTrigger.remove();
      return $row;
    }

    const inviterActions = [ 'remove' ];
    const inviteeActions = [ 'accept', 'decline' ];
    if (this.userIsInviter) {
      // remove invitee actions
      inviteeActions.forEach(action => {
        $row.find(`[data-coapps-table="actions-${action}"]`).remove();
      });
    } else {
      // remove inviter actions
      inviterActions.forEach(action => {
        $row.find(`[data-coapps-table="actions-${action}"]`).remove();
      });
    }

    return $row;
  }

  onActionsTrigger(e) {
    console.log('actions trigger clicked');
    e.preventDefault();
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-coapps-table="row"]');
    const $actionsBody = $row.find('[data-coapps-table="actions-body"]');

    $actionsBody.toggleClass('open');
  }

  onRemoveCoapplicant(e) {
    const $removeCoapplicantModal = $('[data-modal-name="remove-coapplicant"]');
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-coapps-table="row"]');
    const coappEmail = $row.data('coapp-row-id');

    $removeCoapplicantModal
      .find('[data-form-action="confirm-remove-coapplicant"]')
      .attr('data-coapp-email', coappEmail);
    
    console.log('remove coapplicant clicked');
    Modal.open('remove-coapplicant');
  }

  async onConfirmRemoveCoapplicant() {
    // request to remove coapplicant
    const $removeCoapplicantModal = $('[data-modal-name="remove-coapplicant"]');
    const $confirmButton = $removeCoapplicantModal.find('[data-form-action="confirm-remove-coapplicant"]');
    const coappEmail = $removeCoapplicantModal.find('[data-form-action="confirm-remove-coapplicant"]').data('coapp-email');
    console.log('confirm remove coapplicant clicked: ', coappEmail);

    $confirmButton.find('.button_form_label').text('Removing...');
    
    const removeReq = await coappRemove(grapp.user.auth.email, coappEmail);
    if (removeReq.success) {
      // remove coapplicant from table
      this.$body.find(`[data-coapp-row-id="${coappEmail}"]`).remove();
      Modal.close('remove-coapplicant');
      EventBus.emit('toast', { message: 'Coapplicant removed.', type: 'success' });
    } else {
      // show error message
      console.error('Error removing coapplicant');
      Modal.close('remove-coapplicant');
      EventBus.emit('toast', { message: 'Error removing coapplicant.', type: 'error' });
    }
    $confirmButton.find('.button_form_label').text('Yes');
  }

  async onAcceptCoapplicant(e) {
    // request to accept coapplicant
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-coapps-table="row"]');
    const coappEmail = $row.data('coapp-row-id');
    console.log('accept coapplicant clicked: ', coappEmail);

    const acceptReq = await coappAccept(grapp.user.auth.email, coappEmail);
    if (acceptReq.success) {
      // update coapplicant status in table
      const $statusIcon = this.$body.find(`[data-coapp-row-id="${coappEmail}"] [data-coapps-table="coapp-status"] div`).first();
      const $statusLabel = this.$body.find(`[data-coapp-row-id="${coappEmail}"] [data-coapps-table="coapp-status"] div`).last();
      $statusLabel.text('Connected');
      $statusIcon.addClass('bg_secondary');
      EventBus.emit('toast', { message: 'Coapplicant accepted.', type: 'success' });
    } else {
      // show error message
      console.error('Error accepting coapplicant');
      EventBus.emit('toast', { message: 'Error accepting coapplicant.', type: 'error' });
    }
  }

  async onDeclineCoapplicant(e) {
    // request to decline coapplicant
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-coapps-table="row"]');
    const coappEmail = $row.data('coapp-row-id');
    console.log('decline coapplicant clicked: ', coappEmail);

    const declineReq = await coappDecline(grapp.user.auth.email, coappEmail);
    if (declineReq.success) {
      // update coapplicant status in table
      const $statusIcon = this.$body.find(`[data-coapp-row-id="${coappEmail}"] [data-coapps-table="coapp-status"] div`).first();
      const $statusLabel = this.$body.find(`[data-coapp-row-id="${coappEmail}"] [data-coapps-table="coapp-status"] div`).last();
      $statusLabel.text('App Declined');
      $statusIcon.addClass('bg_text_light');
      EventBus.emit('toast', { message: 'Coapplicant declined.', type: 'success' });
    } else {
      // show error message
      console.error('Error declining coapplicant');
      EventBus.emit('toast', { message: 'Error declining coapplicant.', type: 'error' });
    }
  }

  static init() {
    $('[data-js-component="coapps-table"]').each((i, el) => new CoappsTable(el));
  }
}

CoappsTable.init();
